/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/* eslint-disable @typescript-eslint/ban-types */

type DecorateFn<T> = (target: Object, fn: T) => T;

export default function createMethodDecorator(name: string, decorate: DecorateFn<any>): MethodDecorator {
    return (target, key, descriptor) => {
        /*
         * Workaround for Internet Explorer:
         * IE11 can evaluate the property getter while calling Object.defineProperty
         */
        let defining = false;
        return {
            configurable: true,
            get(this: object) {
                if (defining || this === (target as any).prototype || this.hasOwnProperty(key)) {
                    console.error(`@${name}: ${key.toString()} -- property getter invoked with wrong object`);
                    return descriptor.value;
                }
                const decorated = decorate(this, descriptor.value || (descriptor.get && descriptor.get.apply(this)));
                defining = true;
                Object.defineProperty(this, key, {
                    configurable: true,
                    writable: true,
                    value: decorated,
                });
                defining = false;
                return decorated;
            },
        };
    };
}
